module.exports = __webpack_public_path__ + "img/juliaAndAlexanderRing.86d37fc.webp";